import { useEditor } from "@smartfire/js-block-engine";
import { useCallback, useEffect } from "react";

export const useIntersect = (ref, callback, ratio = 1) => {
  const { isEditing } = useEditor();

  const handleIntersect = useCallback(
    (entries) => {
      entries.forEach(callback);
    },
    [callback]
  );

  useEffect(() => {
    if (isEditing || !ref?.current) {
      return;
    }
    const observer = new IntersectionObserver(handleIntersect, {
      root: null,
      rootMargin: "0px",
      threshold: ratio,
    });
    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [isEditing, ref, handleIntersect, ratio]);
};
